import React, { Component } from "react";
import Flatpickr from "react-flatpickr";
import { Button } from "@mui/material";
import { IFilterParams } from "ag-grid-community";
import { IFilterReactComp } from "ag-grid-react";
import moment from "moment";
import styles from "components/portfolio/customerFilters/DatePickerFilter.module.scss";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import { AddCalendarForDatePicker } from "components/app/AddCalendarForDatePicker";

interface DatePickerFilterParams {
  title: string | undefined;
  filterActive: boolean;
  date: Date[];
  nextDays: string;
  userInputDays: string;
  userInputDate: Date[];
  /**
   * @desc option to display in next days
   */
  orInNextDisplay: boolean;
}

class DatePickerFilter
  extends Component<IFilterParams, DatePickerFilterParams>
  implements IFilterReactComp
{
  constructor(props: IFilterParams) {
    super(props);

    this.state = {
      title: props.colDef.headerName,
      filterActive: false,
      date: [],
      nextDays: "",
      userInputDays: "",
      userInputDate: [],
      orInNextDisplay: props.colDef.filterParams?.orInNextDisplay ?? true,
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    // this.datePicker = createRef();
  }

  // componentDidMount() {
  //   flatpickr(this.datePicker.current, {
  //     mode: "range",
  //     dateFormat: "m/d/Y",
  //     onChange: this.onChange,
  //   });
  // }

  // Return true if the filter is active. If active then 1) the grid will show the filter icon in the column
  // header and 2) the filter will be included in the filtering of the data.
  isFilterActive() {
    return this.state.filterActive;
  }

  doesFilterPass() {
    return true;
  }

  getModel() {
    const { date, filterActive, nextDays, userInputDays, userInputDate, orInNextDisplay } =
      this.state;
    if (date.length === 2 && filterActive) {
      const startDate = orInNextDisplay
        ? moment(date[0]).format("YYYY-MM-DD")
        : moment(date[0]).format("YYYY-MM-DD");
      const endDate = orInNextDisplay
        ? moment(date[1]).format("YYYY-MM-DD")
        : moment(date[1]).format("YYYY-MM-DD");

      return {
        filterType: "datePickerFilter",
        type: "between",
        filter: `${startDate}|${endDate}`,
        customizedParam: {
          date: date,
          nextDays: nextDays,
          userInputDays: userInputDays,
          userInputDate: userInputDate,
        },
      };
    } else if (userInputDate.length === 2 && filterActive) {
      const startDate = moment(userInputDate[0]).format("YYYY-MM-DD");
      const endDate = moment(userInputDate[1]).format("YYYY-MM-DD");

      return {
        filterType: "datePickerFilter",
        type: "between",
        filter: `${startDate}|${endDate}`,
        customizedParam: {
          date: date,
          nextDays: nextDays,
          userInputDays: userInputDays,
          userInputDate: userInputDate,
        },
      };
    } else {
      return null;
    }
  }

  setModel(model: any) {
    if (!!model) {
      const { filter, customizedParam } = model;
      if (filter && customizedParam) {
        const { date, nextDays, userInputDays, userInputDate } = customizedParam;
        this.setState(
          {
            date: date,
            filterActive: true,
            nextDays: nextDays,
            userInputDays: userInputDays,
            userInputDate: userInputDate,
          },
          () => {
            this.props.filterChangedCallback();
          }
        );
      }
    } else {
      this.setState(
        {
          date: [],
          filterActive: false,
          nextDays: "",
          userInputDays: "",
          userInputDate: [],
        },
        () => {
          this.props.filterChangedCallback();
        }
      );
    }
  }

  onButtonClick(type: "clear" | "apply") {
    switch (type) {
      case "clear":
        return () => {
          this.setState(
            {
              filterActive: false,
              date: [],
              nextDays: "",
              userInputDays: "",
              userInputDate: [],
            },
            () => {
              // this.datePicker.current.value = "";
              this.props.filterChangedCallback();
            }
          );
        };
      case "apply":
        return () => {
          this.setState(
            {
              filterActive: true,
            },
            () => {
              this.props.filterChangedCallback();
            }
          );
        };
    }
  }

  onDateChange(date: Date[]) {
    this.setState({
      date,
      nextDays: "",
      userInputDays: "",
      userInputDate: [],
    });
  }

  handleInNextChange = (event: any) => {
    this.setState({
      date: [],
      nextDays: event.target.value,
      userInputDays: "",
      userInputDate:
        event.target.value !== "userInput"
          ? [
              new Date(),
              new Date(
                new Date().getTime() + Math.max(event.target.value - 1, 0) * 24 * 3600 * 1000
              ),
            ]
          : [],
    });
  };

  handleUserInputFocus = () => {
    this.setState({
      date: [],
      nextDays: "userInput",
      userInputDate: [],
    });
  };

  handleUserInputChange = (event: any) => {
    event.target.value =
      event.target.value.replace(/\D/g, "") > 999 ? 999 : event.target.value.replace(/\D/g, "");
    this.setState({
      userInputDays: event.target.value,
      userInputDate: [
        new Date(),
        new Date(new Date().getTime() + Math.max(event.target.value - 1, 0) * 24 * 3600 * 1000),
      ],
    });
  };

  render() {
    const { date, filterActive, nextDays, userInputDays, userInputDate, orInNextDisplay } =
      this.state;

    return (
      <div>
        {/* <div>
          <p className={styles.filterTitle}>{title}</p>
        </div> */}
        <div className={styles.filterWrapper}>
          <Flatpickr
            options={{
              mode: "range",
              dateFormat: "m/d/Y",
              animate: true,
            }}
            value={date}
            onChange={this.onDateChange}
            render={({ value: pickDate }, ref) => AddCalendarForDatePicker(pickDate, ref)}
          />
        </div>
        {orInNextDisplay && (
          <FormControl
            component="fieldset"
            className={styles.orInNextWrpper}
          >
            <FormLabel
              component="legend"
              className={styles.orInNextTitle}
            >
              Or in next
            </FormLabel>
            <RadioGroup
              aria-label="orInNext"
              name="orInNext"
              value={nextDays}
              className={styles.orInNextRadioGroup}
              onChange={this.handleInNextChange}
            >
              {["7", "15", "30", "45", "60", "90", "userInput"].map((value) => {
                return value === "userInput" ? (
                  <FormControlLabel
                    key={value}
                    value={value}
                    control={
                      <Radio
                        size="small"
                        color="primary"
                      />
                    }
                    label={
                      <span>
                        <TextField
                          className={styles.orInNextUserInput}
                          onChange={this.handleUserInputChange}
                          onFocus={this.handleUserInputFocus}
                          value={userInputDays}
                          variant="standard"
                        />
                        <span> Day(s)</span>
                      </span>
                    }
                  />
                ) : (
                  <FormControlLabel
                    key={value}
                    value={value}
                    control={
                      <Radio
                        size="small"
                        color="primary"
                      />
                    }
                    label={`${value} Days`}
                  />
                );
              })}
            </RadioGroup>
          </FormControl>
        )}
        <div className="ag-filter-apply-panel">
          <Button
            variant="text"
            disabled={!filterActive}
            onClick={this.onButtonClick("clear")}
            className="ag-standard-button ag-filter-apply-panel-button"
          >
            Reset filter
          </Button>
          <Button
            disabled={this.state.date.length !== 2 && userInputDate.length !== 2}
            variant="text"
            onClick={this.onButtonClick("apply")}
            className="ag-standard-button ag-filter-apply-panel-button"
          >
            Apply filter
          </Button>
        </div>
      </div>
    );
  }
}

export default DatePickerFilter;
